import PropTypes from 'prop-types';
import React from 'react';
import { useIntl } from 'react-intl';

import {
  Box,
  Heading,
  makeStyles,
  Spacing,
  DefaultTheme,
  Text
} from 'groundkeeper-component-library';

import Drawer from '../components/Drawer';
import Link from '../components/Link';

const useStyles = makeStyles((theme: DefaultTheme) => ({
  unstyledList: {
    margin: 0,
    listStyle: 'none',
    paddingLeft: 0,
    '& li': {
      marginBottom: theme.spacing(1)
    }
  },
  groupsList: {
    margin: 0,
    marginTop: theme.spacing(0.5),
    listStyle: 'none',
    paddingLeft: 0,
    '& > li': {
      marginBottom: theme.spacing(0.5)
    }
  }
}));
export default function ClusterDrawer(props) {
  const intl = useIntl();
  const classes = useStyles();
  const { cluster } = props;

  return (
    <Drawer
      data-testid="drawers/cluster-drawer"
      open={props.open}
      onClose={props.onClose}
    >
      <Box p={3} pt={2}>
        <Heading type="h2">
          {intl.formatMessage({
            id: 'cluster',
            defaultMessage: 'Cluster'
          })}
        </Heading>
        <Text>
          {intl.formatMessage({
            id: 'cluster_info_text_long',
            defaultMessage: 'cluster_info_text_long.'
          })}
        </Text>
        <Spacing y={2} />
        <ul className={classes.unstyledList}>
          <li>
            <strong>
              {intl.formatMessage({
                id: 'name',
                defaultMessage: 'Name'
              })}
            </strong>
            <br /> {cluster.name}
          </li>
          {cluster.groups?.length > 0 ? (
            <li>
              <strong>
                {intl.formatMessage({
                  id: 'groups',
                  defaultMessage: 'Groups'
                })}
              </strong>
              <ul className={classes.groupsList}>
                {cluster.groups.map(g => (
                  <li key={g.id}>
                    <Link onClick={props.onClose} href={`/groups/${g.id}`}>
                      {g.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </li>
          ) : null}
        </ul>
      </Box>
    </Drawer>
  );
}

ClusterDrawer.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  cluster: PropTypes.object,
  open: PropTypes.bool,
  onClose: PropTypes.func
};

ClusterDrawer.defaultProps = {
  ClusterDrawer: null
};
